export default {
  es: {
    titleSuccess: 'Todos los servicios están operativos',
    titleWarning: 'Algunos servicios están fuera de línea',
    titleError: 'Todos los servicios están fuera de línea',
    stateOn: 'Operativo',
    stateOff: 'Fuera de Línea',
    loading: 'Cargando...'
  },
  en: {
    titleSuccess: 'All services are operative',
    titleWarning: 'Some services are offline',
    titleError: 'All services are offline',
    stateOn: 'Online',
    stateOff: 'Offline',
    loading: 'Loading...'
  }
};
